import type { AppAction } from "../app.types"
import type { Attachment } from "../projects/projects.types"
import type { FormAttachment } from "./../../components/organisms/map-attachment-edit-dialog/map-attachment-edit-dialog.component"
export interface IAttachmentEditorState {
  currentAttachment?: Attachment
  highlightAttachment?: Attachment
  dialogOpen: boolean
  isCreating: boolean
  currentlyEditing?: FormAttachment
}

export enum AttachmentEditorStates {
  DataForm = 0,
  SetLocation = 1,
  Overview = 2
}

export type AttachmentEditorActions = AttachmentEditorAction | AttachmentEditorStateAction | AttachmentEditorEditAction

export type AttachmentEditorAction = AppAction<Attachment>
export type AttachmentEditorEditAction = AppAction<FormAttachment>
export type AttachmentEditorStateAction = AppAction<AttachmentEditorStates>
